<div class="mat-dialog-custom geo-file-import-modal">
  <div class="title-container display-flex-container">
    <h1 class="title">{{ this.vm.pageTitle }}</h1>
    <button
      id="closeImportRide"
      class="close button button-link"
      type="button"
      aria-label="close"
      (click)="onCancel()"
      i18n-aria-label
    >
      <svg-icon src="/assets/icons/close.svg" alt="close" i18n-alt />
    </button>
  </div>

  @if ((!vm.file || vm.errorMessage) && !isLoading && !vm.processing) {
    <div class="body-container">
      <rdx-geo-file-import-upload
        [errorMessage]="vm.errorMessage"
        [errorMessageDetail]="vm.errorMessageDetail"
        (fileSelected)="onFileSelected($event)"
      />
    </div>
  }

  @if (vm.file && !isLoading && !vm.processing && !vm.errorMessage) {
    <div class="body-container">
      <form>
        @if (vm.item) {
          <div class="top-container" [ngClass]="{ collection: vm.isCollection }">
            @if (!vm.isCollection) {
              <div class="color-picker-container">
                <div #colorPicker id="colorPicker" class="inner-container" [hidden]="!isShowColorPickerShowing">
                  <rdx-color-picker
                    class="color-picker"
                    [initialColor]="vm.itemColor || 'Blue'"
                    [id]="vm.item.id"
                    (colorChanged)="onColorChanged($event)"
                  />
                </div>
                <div class="triangle-bottom"></div>
                <a
                  id="openColorPicker"
                  class="icon-container"
                  type="button"
                  href="javascript: void(0);"
                  [ngClass]="vm.itemColor ? ('profile-' + vm.itemColor | lowercase) : 'profile-blue'"
                  (click)="onToggleColorPicker($event)"
                >
                  <svg-icon
                    src="/assets/icons/paint-brush.svg"
                    svgAriaLabel="color picker"
                    [class]="vm.itemColor ? 'icon-fill' : ''"
                    i18n-svgAriaLabel
                  />
                </a>
              </div>
            }
            @if (!vm.isCollection) {
              <mat-form-field>
                <mat-label>{{ vm.itemNamePlaceholder }}</mat-label>
                <input
                  id="gpxName"
                  name="name"
                  matInput
                  required
                  [formControl]="nameFormControl"
                  [(ngModel)]="vm.item.name"
                  (change)="vm.refreshMap()"
                />
                @if (nameFormControl.errors?.['required']) {
                  <mat-error class="material-error" i18n>Please enter a name.</mat-error>
                }
              </mat-form-field>
            }
            @if (vm.showRideTypeSelector) {
              <div class="cta" i18n>Show on maps:</div>
              <mat-radio-group
                class="ride-type"
                name="rideType"
                required
                [(ngModel)]="vm.rideType"
                (change)="vm.changeRideType()"
              >
                <div class="map-type">
                  <mat-radio-button id="selectOffRoad" value="OffRoad" aria-label="Off-Road" i18n-aria-label />
                  <div>
                    <div class="label">
                      <svg-icon src="/assets/icons/orv.svg" svgAriaLabel="off-road" i18n-svgAriaLabel />
                      <span i18n>Off-Road</span>
                    </div>
                  </div>
                </div>
                <div class="map-type">
                  <mat-radio-button id="selectSnow" value="Snow" aria-label="Snow" i18n-aria-label />
                  <div>
                    <div class="label">
                      <svg-icon src="/assets/icons/snow.svg" svgAriaLabel="snow" i18n-svgAriaLabel />
                      <span i18n>Snow</span>
                    </div>
                  </div>
                </div>
              </mat-radio-group>
            }
          </div>
        }
      </form>

      <div class="middle-container">
        <div class="map-container" [ngClass]="{ collection: vm.isCollection }">
          <rdx-map
            containerId="geoFileImportMap"
            [disableDragPan]="true"
            [enableMapLegend]="false"
            [enableMapTypeToggle]="false"
            [initialBounds]="vm.bounds"
            [initializeInSatellite]="false"
            [showLabelledPois]="false"
            [enableMapControls]="false"
            [plannedRides$]="vm.plannedRides$"
            [trackedRides$]="vm.trackedRides$"
            [waypoints$]="vm.waypoints$"
            [geofences$]="vm.geofences$"
            [enableRadarWeather]="false"
            [enableCloudCover]="false"
            (mapInitialized)="onMapInitialized($event)"
          />
        </div>

        @if (vm.isCollection) {
          <div class="collection-list-container">
            <mat-form-field class="helper-full-width">
              <mat-label i18n>Collection Name</mat-label>
              <input
                id="gpxName"
                name="name"
                matInput
                required
                [formControl]="nameFormControl"
                [(ngModel)]="vm.item.name"
              />
              @if (nameFormControl.errors?.['required']) {
                <mat-error class="material-error" i18n>Please enter a name.</mat-error>
              }
            </mat-form-field>
            <div class="list">
              <div class="select-all-row">
                <mat-checkbox
                  id="cbxSelectAll"
                  [checked]="vm.itemCount === vm.selectedItemCount"
                  (change)="onSelectAllChanged()"
                  i18n
                  >Select All</mat-checkbox
                >
              </div>
              @for (item of vm.all$ | async; track $index) {
                <div
                  class="list-item"
                  [ngClass]="{ active: item.editing, 'map-hover': item.hoveredOnMap }"
                  (mouseenter)="onEnterItem(item.feature)"
                  (mouseleave)="onLeaveItem()"
                >
                  <mat-checkbox [checked]="item.checked" [(ngModel)]="item.checked" />
                  <div [class]="item.feature.color || vm.itemColor || 'color-main' | lowercase">
                    <svg-icon
                      svgClass="icon-img item"
                      [hidden]="item.editing"
                      [src]="item.icon"
                      [svgAriaLabel]="item.feature.name"
                      i18n-svgAriasvgAriaLabel
                    />
                    <div
                      #colorPicker
                      id="colorPicker"
                      class="item-color-picker-container"
                      [hidden]="!item.editingColor"
                    >
                      <rdx-color-picker
                        class="color-picker"
                        [initialColor]="item.color || 'Blue'"
                        [id]="item.feature.id"
                        (colorChanged)="onCollectionItemColorChanged($event, item)"
                      />
                    </div>
                    <div class="triangle-bottom"></div>
                    <a
                      id="openColorPicker"
                      class="icon-container"
                      type="button"
                      href="javascript: void(0);"
                      [ngClass]="vm.itemColor ? ('profile-' + vm.itemColor | lowercase) : 'profile-blue'"
                      (click)="onToggleCollectionItemColorPicker(item)"
                    >
                      <svg-icon
                        src="/assets/icons/paint-brush.svg"
                        svgClass="icon-img color-picker"
                        svgAriaLabel="color picker"
                        i18n-svgAriaLabel
                      />
                    </a>
                  </div>
                  @if (!item.editing) {
                    <div class="info">
                      <a href="javascript:void(0);" (click)="onEditItem(item)">
                        <div class="helper-truncate" [title]="item.feature.name">{{ item.feature.name }}</div>
                        <div class="helper-secondary-text details">
                          @if (item.itemLength) {
                            <div>
                              <pii-distance-display [distanceInMeters]="item.itemLength" />
                            </div>
                          }
                          @if (item.itemDuration) {
                            <div>
                              <pii-duration-display [durationInSeconds]="item.itemDuration" />
                            </div>
                          }
                          @if (item.itemSize) {
                            <div>
                              <rdx-area-display [areaInMeters]="item.itemSize" />
                            </div>
                          }
                        </div>
                      </a>
                    </div>
                    <div>
                      <a href="javascript:void(0);" (click)="onEditItem(item)">
                        <svg-icon
                          class="edit-icon"
                          src="/assets/icons/edit.svg"
                          alt="edit"
                          aria-label="edit"
                          i18n-aria-label
                          i18n-alt
                        />
                      </a>
                    </div>
                  } @else {
                    <div class="info">
                      <input
                        #input
                        id="itemName"
                        class="item-name"
                        name="name"
                        onfocus="this.select()"
                        matInput
                        [(ngModel)]="item.feature.name"
                        (blur)="onStopEdit(item)"
                        (keydown.enter)="onStopEdit(item)"
                        (keydown.esc)="$event.stopPropagation(); onStopEdit(item)"
                      />
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="footer-container">
        <div class="buttons-container">
          <button
            id="fileImport"
            class="primary-button button import-button"
            type="button"
            [disabled]="vm.submitting || nameFormControl.invalid"
            (click)="onImport()"
          >
            @if (!vm.processing && !vm.submitting) {
              <span i18n>Import</span>
            }
            @if (vm.submitting) {
              <span i18n>Importing...</span>
            }
          </button>
          <button id="cancelFileImport" class="secondary-button button" type="button" (click)="onCancel()" i18n>
            Cancel
          </button>
        </div>
        <div class="stats-container">
          @if (vm.itemDate) {
            <div class="stats-item date-item">
              <svg-icon src="/assets/icons/calendar.svg" svgAriaLabel="date" i18n-svgAriaLabel />
              <span>{{ vm.itemDate | date }}</span>
            </div>
          }
          @if (vm.itemLength) {
            <div class="stats-item">
              <svg-icon src="/assets/icons/distance-v2.svg" svgAriaLabel="distance" i18n-svgAriaLabel />
              <pii-distance-display [distanceInMeters]="vm.itemLength" />
            </div>
          }
          @if (vm.itemDuration) {
            <div class="stats-item">
              <svg-icon src="/assets/icons/time.svg" svgAriaLabel="time" i18n-svgAriaLabel />
              <pii-duration-display [durationInSeconds]="vm.itemDuration" />
            </div>
          }
          @if (vm.itemSize) {
            <div class="stats-item">
              <rdx-area-display [areaInMeters]="vm.itemSize" />
            </div>
          }
          @if (vm.itemCount) {
            <div class="stats-item">
              <svg-icon src="/assets/icons/collection.svg" svgAriaLabel="collection" i18n-svgAriaLabel />
              @if (vm.selectedItemCount !== 0) {
                <span i18n>{{ vm.selectedItemCount }} items</span>
              } @else {
                <span class="space error" i18n>Select at least 1 item</span>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }

  @if (isLoading) {
    <div class="file-drop">
      <mat-progress-spinner mode="indeterminate" />
    </div>
  }

  @if (vm.processing) {
    <div class="processing">
      <h3 i18n>Importing {{ vm.importCount }} items</h3>
      <div class="processing-message" i18n>
        <div>Wait here or close this popup and the import</div>
        <div>will continue in the background.</div>
      </div>
      <div class="processing-bar">
        <mat-progress-bar mode="determinate" [value]="vm.percentageComplete" />
      </div>
    </div>
  }
</div>
